<template>
    <div>
          <!-- <div class="slected_items">
            <ul>
                <li class="dropdown-list">
                    <vs-dropdown ref="tagDropdown" vs-custom-content vs-trigger-click class="cursor-pointer menu__label IB_tooltip" >
                        <span>+</span>
                        <div class="tooltip_cnt right"><p>Add to USCIS Folders</p></div>
                        <vs-dropdown-menu color="#fff" class="vx-navbar-dropdown"  >
                            <VuePerfectScrollbar
                            ref="mainSidebarPss"
                            class="scroll-area--main-sidebar"
                            :settings="settings"
                            @ps-scroll-y="scroll">
                            <ul class="document_tags_list">
                                <template v-for="(tag, ind) in tagsList">
                                    <li > 
                                        <vs-checkbox v-model="tag.isSelected" @change="updateData()" :key="ind">
                                            {{ tag['name'] }}
                                        </vs-checkbox>
                                    </li>
                                </template>
                            </ul>
                            </VuePerfectScrollbar> 
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </li>
            </ul>
        </div>
        <ul class="uploaded-list">
            <template v-if="checkProperty(tagsList, 'length')>0">
                <template v-for="(tag, index) in tagsList">
                    <template v-if="checkProperty(tag, 'isSelected')">
                        <vs-chip @click="tag.isSelected = false;updateData()" closable>
                            {{ tag['name'] }}
                        </vs-chip>
                    </template>
                </template>
            </template> 
        </ul>   -->
    
        <div class="list-chips">
            <ul class="label_list" >
            <li class="label_new" v-if="checkSelectedLabel">Add to USCIS Folders</li>
            <template v-if="checkProperty(tagsList, 'length')>0"> 
                <template v-for="(tag, index) in tagsList">
                    <li v-if="checkProperty(tag, 'isSelected')">
                        {{ tag['name'] }} <em   @click="tag.isSelected = false;updateMethods(tag)">x</em>
                    </li>
                    <template v-if="checkProperty(tag, 'subTagList') && checkProperty(tag, 'subTagList', 'length')>0">
                        <template v-for="(subItem, inde) in tag['subTagList']">
                            <li v-if="checkProperty(subItem, 'isSelected')">
                                {{ subItem['name'] }} <em   @click="subItem.isSelected = false;updateSubTags(subItem)">x</em>
                            </li>
                        </template>
                    </template>
                </template>
            </template>
            <!-- updateData -->
            <li class="p-0 add_li">
                    <vs-dropdown ref="addLabelDropdown" vs-custom-content vs-trigger-click class="cursor-pointer add_new_label" >  
                        <span>+</span>
                        <div class="tooltip_cnt">
                            <p>Add to USCIS Folders</p>
                        </div>
                    <vs-dropdown-menu color="#fff" class="vx-navbar-dropdown list-chips-dropdown"  >
                        <VuePerfectScrollbar>
                        <ul style="min-width: 9rem" class="profileMenu" >
                            <template v-for="(tag, ind) in tagsList">
                                <li>
                                    <vs-checkbox v-model="tag.isSelected" @change="updateMethods(tag)" :key="ind">
                                        {{ tag['name'] }}
                                    </vs-checkbox>
                                    <ul v-if="checkProperty(tag, 'subTagList') && checkProperty(tag, 'subTagList', 'length')>0">
                                        <template v-for="(cTag, inde) in tag['subTagList']">
                                            <li>
                                                <vs-checkbox v-model="cTag.isSelected" @change="updateSubTags(cTag)" :key="inde">
                                                    {{ cTag['name'] }}
                                                </vs-checkbox>
                                            </li>
                                        </template>
                                        
                                    </ul>
                                </li>
                            </template> 
                        </ul>
                        </VuePerfectScrollbar>
                    </vs-dropdown-menu>
                    </vs-dropdown>
            </li>
            </ul>
            
        </div>
    
    </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import _ from "lodash";
export default {
    props: {
        eFileTagsList:{
            type:Array,
            default:[]
        },
        petition:{
            type:Object,
            default:null
        },
        docType:{
            type:String,
            default:''
        },
        documents:null,
        category:{
            type:String,
            default:''
        },
        petitionId:{
            type:String,
            default:''
        },
        childId:{
            type:String,
            default:''
        },
        callFromScanned:{
            type:Boolean,
            default:false
        },
        callFromPetitionDocs:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return{
            debounce:null,
            settings: { },
            tagsList:[{id:1,'isSelected':false, name:'Certified labor condition application'},
                {id:2,'isSelected':false,  name:'Evidence of qualified specialty occupation'},
                {id:3,'isSelected':false,  name:'Degree or evidence of specialized training'},
                {id:4, 'isSelected':false, name:'Written contract or terms of agreement'}
            ]
        }
    },
    components: {
        VuePerfectScrollbar,
    },
    methods: {
        updateSubTags(item){
            let self = this;
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                let selectedObj = item;
                let action = selectedObj['isSelected']
                _.forEach(self.tagsList, (mItem)=>{
                    if(mItem['id'] == selectedObj['tagId']){
                        _.forEach(mItem['subTagList'], (sTags)=>{
                            if(sTags['id'] != selectedObj['id']){
                                sTags['isSelected'] = false
                            }
                        });
                        if(action){
                            mItem['isSelected'] = true
                        }
                        // else{
                        //     mItem['isSelected'] = false
                        // }
                    }
                })
                self.tagsList = _.cloneDeep(self.tagsList);
                self.updateData(true)
            })
        },
        updateMethods(item = null,callFromSub=false){
            let self = this;
            clearTimeout(this.debounce)
            this.debounce = setTimeout(() => {
                let selectedObj = item;
                let action = selectedObj['isSelected'];
                if(!action){
                    _.forEach(self.tagsList, (mItem)=>{
                        if(mItem['id'] == selectedObj['id']){
                            if(mItem['subTagList'] && mItem['subTagList'].length>0){
                                _.forEach(mItem['subTagList'], (sTags)=>{
                                    sTags['isSelected'] = false
                                });
                            }
                        }
                    })
                }
                self.tagsList = _.cloneDeep(self.tagsList);
                self.updateData();
            })
        },
        scroll(){},
        updateData(callFromSub=false){
            if(this.callFromScanned){
                this.updateScannedDocs(callFromSub)
            }else if(this.callFromPetitionDocs){
                this.updatePetitionDocsData(callFromSub)
            } else{
                this.updateDocsData()
            }
        },
        updatePetitionDocsData(callFromSub = false){
            let payLoad = {
                docType:this.docType,
                petitionId:this.checkProperty(this.petition, '_id'),
                category:this.category,
                entityType:'case',
                efileDocTagIds:[],
                documents:null,
                subCategory:'Single'
            };
            if(callFromSub){
                payLoad['efileSubTag'] = true
            }
            let ids = [];
            let subIds = [];
            _.forEach(this.tagsList, (tIm)=>{
                if(tIm['isSelected']){
                    ids.push(tIm['id']);
                    if(this.checkProperty(tIm, 'subTagList') && this.checkProperty(tIm, 'subTagList', 'length')>0){
                        _.forEach(tIm['subTagList'], (sTIm)=>{
                            if(sTIm['isSelected']){
                                subIds.push(sTIm['id']);
                            }
                        })
                        
                    }
                }
            });
            this.documents['efileDocTagIds'] = ids;
            this.documents['efileDocSubTagIds'] = subIds;
            payLoad['efileDocTagIds'] = ids;
            payLoad['documents'] = this.documents;
            this.$store.dispatch('commonAction', {data:payLoad, path:'/petition-common/update-efile-doc-tags'}).then((res)=>{

            }).catch((err)=>{

            })
        },
        updateDocsData(){
            let payLoad = {
                petitionId:this.petitionId,
                docType:this.docType,
                category:this.category,
                entityType:'case'
            }
            if(this.documents){
                let ids = [];
                _.forEach(this.tagsList, (tIm)=>{
                    if(tIm['isSelected']){
                        ids.push(tIm['id']);
                    }
                });
                _.forEach(this.documents, (dItem)=>{
                    dItem['efileDocTagIds'] = ids;
                })
                payLoad['documents'] = this.documents;
            }
            if(this.childId){
                payLoad['childId'] = this.childId
            }
            this.$store.dispatch('commonAction', {data:payLoad, path:'/petition-common/update-efile-doc-tags'}).then((res)=>{

            }).catch((err)=>{

            })
        },
        updateScannedDocs(callFromSub = false){
            let payLoad = {
                petitionId:this.checkProperty(this.petition, '_id'),
                signDocId:this.checkProperty(this.documents, '_id'),
                category:'Signed-docs',
                entityType:'case',
                efileDocTagIds:[],
                documents:null
            };
            if(callFromSub){
                payLoad['efileSubTag'] = true
            }
            let ids = [];
            let subIds = [];
            _.forEach(this.tagsList, (tIm)=>{
                if(tIm['isSelected']){
                    ids.push(tIm['id']);
                    if(this.checkProperty(tIm, 'subTagList') && this.checkProperty(tIm, 'subTagList', 'length')>0){
                        _.forEach(tIm['subTagList'], (sTIm)=>{
                            if(sTIm['isSelected']){
                                subIds.push(sTIm['id']);
                            }
                        })
                        
                    }
                }
            });
            this.documents['efileDocTagIds'] = ids;
            payLoad['efileDocTagIds'] = ids;
            this.documents['efileDocSubTagIds'] = subIds;
            payLoad['efileDocSubTagIds'] = subIds;
            payLoad['documents'] = this.documents;
            this.$store.dispatch('commonAction', {data:payLoad, path:'/petition-common/update-efile-doc-tags'}).then((res)=>{

            }).catch((err)=>{

            })
        }
    },
    mounted() {
        if(this.eFileTagsList && this.eFileTagsList.length>0){
            this.tagsList = _.cloneDeep(this.eFileTagsList)
        }
        if(this.callFromScanned){
            if(this.documents){
                if(_.has(this.documents, 'efileDocTagIds') && this.checkProperty(this.documents, 'efileDocTagIds', 'length')>0){
                    _.forEach(this.tagsList, (tIm)=>{
                        if(this.documents['efileDocTagIds'].indexOf(tIm['id'])>-1){
                            tIm['isSelected'] = true;
                            if(this.documents['efileDocSubTagIds'] && this.checkProperty(this.documents, 'efileDocSubTagIds', 'length')>0){
                                if(this.checkProperty(tIm, 'subTagList') && this.checkProperty(tIm, 'subTagList', 'length')>0){
                                    _.forEach(tIm['subTagList'], (cItem)=>{
                                        if(this.documents['efileDocSubTagIds'].indexOf(cItem['id'])>-1){
                                            cItem['isSelected'] = true;
                                        }
                                    })
                                }
                                
                            }
                        }
                        
                    });
                    this.tagsList = _.cloneDeep(this.tagsList);
                }else{
                    this.documents['efileDocTagIds'] = [];
                }
            }
        }else if(this.callFromPetitionDocs){
            if(this.documents){
                if(_.has(this.documents, 'efileDocTagIds') && this.checkProperty(this.documents, 'efileDocTagIds', 'length')>0){
                    _.forEach(this.tagsList, (tIm)=>{
                        if(this.documents['efileDocTagIds'].indexOf(tIm['id'])>-1){
                            tIm['isSelected'] = true;
                            if(this.documents['efileDocSubTagIds'] && this.checkProperty(this.documents, 'efileDocSubTagIds', 'length')>0){
                                if(this.checkProperty(tIm, 'subTagList') && this.checkProperty(tIm, 'subTagList', 'length')>0){
                                    _.forEach(tIm['subTagList'], (cItem)=>{
                                        if(this.documents['efileDocSubTagIds'].indexOf(cItem['id'])>-1){
                                            cItem['isSelected'] = true;
                                        }
                                    })
                                }
                                
                            }
                        }
                        
                    });
                    this.tagsList = _.cloneDeep(this.tagsList);
                }else{
                    this.documents['efileDocTagIds'] = [];
                }
            }
        }
        else{
            if(this.documents && this.checkProperty(this.documents, 'length')>0){
                let tagsItem = null;
                _.forEach(this.documents, (dItem)=>{
                    if(dItem && _.has(dItem, 'efileDocTagIds') && this.checkProperty(dItem, 'efileDocTagIds', 'length')>0){
                        tagsItem = dItem;
                        return false
                    }
                });
                if(tagsItem && tagsItem !=null && this.checkProperty(tagsItem, 'efileDocTagIds', 'length')>0){
                    _.forEach(this.documents, (doc)=>{
                        doc['efileDocTagIds'] = tagsItem['efileDocTagIds']
                    });
                    this.documents = _.cloneDeep(this.documents);

                    _.forEach(this.tagsList, (tIm)=>{
                        if(tagsItem['efileDocTagIds'].indexOf(tIm['id'])>-1){
                            tIm['isSelected'] = true;
                        }
                    });
                    this.tagsList = _.cloneDeep(this.tagsList);
                }
            }
        }
    },
    computed: {
        checkSelectedLabel(){
            let returnVal = true;
            if(this.checkProperty(this.tagsList, 'length')>0){
                let findObj =_.find(this.tagsList, {'isSelected':true});
                if(findObj){
                    returnVal = false;
                }
            }
            return returnVal
        }
    }
}
</script>